import { Typography } from "@mui/material"
import React from "react"
export const PanelSubscription = (): JSX.Element => {
    return (
        <Typography variant="h5" color="secondary.main">
            Assinatura
        </Typography>
    )
}